import gql from 'graphql-tag';
export const StatFeatureStaffBreakRules = gql `
    fragment StatFeatureStaffBreakRules on StaffBreakRulesFeatureSettingsFlags {
        isEnabled
    }
`;
